export const irMapa = ({lat, long}) => {
    let LINKMAP = `https://www.google.com/maps/dir/?api=1&destination=${lat},${long},190&dir_action=navigate`
    window.open(LINKMAP)

}